module.exports = __webpack_public_path__ + "img/twitter (4).955fa784.svg";